
import React from 'react'
const wrapPageElement = ({ element, props }) => {
  const Layout = element.type.Layout ?? React.Fragment
  return <Layout {...props}>{element}</Layout>
}

export default wrapPageElement
